import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import * as lodash from 'lodash';

@Component({
  selector: 'app-pagination-strip',
  templateUrl: './pagination-strip.component.html',
  styleUrls: ['./pagination-strip.component.scss'],
})
export class PaginationStripComponent implements OnInit, OnChanges {
  // All the applicable values are 1 indexed.
  @Input() min = 1;
  @Input() total: number = null;
  @Input() current: number = null;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<number>();

  private extremesCount = 2;
  private immediatesCount = 3;
  public layout = null;

  ngOnInit(): void {
    this.buildLayout();
  }

  ngOnChanges(_: SimpleChanges): void {
    this.buildLayout();
  }

  buildLayout() {
    if (this.total !== null && this.current !== null) {
      this.layout = {
        previous: this._buildPreviousLayout(),
        next: this._buildNextLayout(),
      };
    }
  }

  _buildPreviousLayout() {
    const shouldShowExtremes = (
      this.current >= (this.extremesCount + this.immediatesCount + 1)
    );

    const immediates = lodash.range(
      shouldShowExtremes
        ? Math.max(this.current - this.immediatesCount, this.min)
        : this.min,
      this.current,
      1,
    );

    const extremes = shouldShowExtremes
      ? lodash.range(
          this.min,
          this.min + this.extremesCount,
          1,
        )
      : [];

    return {
      immediates,
      extremes,
      previous: this.current > this.min
        ? this.current - 1
        : null,
    };
  }

  _buildNextLayout() {
    const shouldShowExtremes = (
      this.current <= this.total - (this.extremesCount + this.immediatesCount)
    );

    const end = shouldShowExtremes
      ? Math.min(this.current + this.immediatesCount, this.total) + 1
      : this.total + 1;

    const immediates = lodash.range(
      this.current + 1,
      end,
      1,
    );

    const extremes = shouldShowExtremes
      ? lodash.range(
          this.total - this.extremesCount + 1,
          this.total + 1,
          1,
        )
      : [];

    return {
      immediates,
      extremes,
      next: this.current < this.total
        ? this.current + 1
        : null,
    };
  }

  onClick(target: number) {
    if (target !== null) {
      this.change.next(target);
    }
  }
}
